import { useMemo, useState } from "react";
import { Applicant } from "types/application";
import { getVerificationTabs } from "../utils";

interface Props {
  applicant: Applicant;
  initialVerificationId?: number;
}

export const useIncomeVerificationsSelectionController = ({
  applicant,
  initialVerificationId
}: Props) => {
  //   * currentlySelectedVerificationId — the tab the user is looking at.
  //     Seeded from initialVerificationId on first render, then swapped by
  //     tab clicks. This is what the report re-fetches against and what the
  //     tabs / header display.
  //
  //   * activeVerificationId — id of the ACTIVE (non-archived) row

  const [currentlySelectedVerificationId, setCurrentlySelectedVerificationId] =
    useState<number | undefined>(initialVerificationId);

  const allCombinedIncomeVerifications =
    applicant.combined_income_verifications;

  const {
    activeCombinedIncomeVerification,
    selectedCombinedIncomeVerification,
    verificationTabs
  } = useMemo(
    () => ({
      activeCombinedIncomeVerification: allCombinedIncomeVerifications?.find(
        (v) => !v.archived_at
      ),
      selectedCombinedIncomeVerification: allCombinedIncomeVerifications?.find(
        (v) => v.id === currentlySelectedVerificationId
      ),
      verificationTabs: getVerificationTabs(allCombinedIncomeVerifications)
    }),
    [allCombinedIncomeVerifications, currentlySelectedVerificationId]
  );

  const activeVerificationId =
    activeCombinedIncomeVerification?.id ?? initialVerificationId;
  const isReadOnlyVerification = Boolean(
    selectedCombinedIncomeVerification?.archived_at
  );

  return {
    currentlySelectedVerificationId,
    setCurrentlySelectedVerificationId,
    activeVerificationId,
    allCombinedIncomeVerifications,
    activeCombinedIncomeVerification,
    selectedCombinedIncomeVerification,
    verificationTabs,
    isReadOnlyVerification
  };
};
